import { useEffect } from 'react'
import { trackElementViewed } from '@/features/shared/analytics/element'
import { datadogRum } from '@datadog/browser-rum'

export const DialogContainerTrackComponent = ({
  type,
  sublocation,
}: {
  type: string
  sublocation?: string
}) => {
  useEffect(() => {
    trackElementViewed({
      type: 'modal',
      content: type,
      message_goal: 'Track how many times a modal is opened',
      display_sublocation: sublocation,
    })
    datadogRum.addAction('openModal', {
      type,
    })
  }, [type, sublocation])

  return null
}
